<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <loading-component>
        <template #content>
            <div class="flex flex-col gap-4 xl:mx-60">
                <div class="flex flex-row items-center gap-4">
                    <back-component></back-component>
                </div>

                <upsert-claim-component v-model="claim" @save="save" />
            </div>
        </template>
    </loading-component>
</template>

<script>
import LoadingComponent from '@/components/LoadingComponent';
import BackComponent from '@/components/BackComponent';
import UpsertClaimComponent from '@/components/claims/UpsertClaimComponent';
import { mapStores } from 'pinia';
import { useClaimsStore } from '@/stores/claims';
import { useApplicationStore } from '@/stores/application';
import Notifications from '@auth/vue-share/utility/notifications';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'EditClaimView',
    props: ['id'],
    components: { UpsertClaimComponent, BackComponent, LoadingComponent },
    data() {
        return {
            claim: undefined
        };
    },
    computed: {
        ...mapStores(useClaimsStore, useApplicationStore)
    },
    async created() {
        this.applicationStore.setLoading(true);

        this.claimsStore.getClaim(this.id).then((response) => {
            this.claim = response.data.data;
            this.applicationStore.setLoading(false);
        });
    },
    methods: {
        save(claim) {
            this.claimsStore
                .updateClaim(claim)
                .then(() => {
                    Notifications.success('Claim erfolgreich gespeichert');
                })
                .catch((error) => {
                    Notifications.error('Der Claim konnte nicht gespeichert werden');
                    logger.error('[CLAIM]', error);
                });
        }
    }
};
</script>

<style scoped></style>
